<template>
    <div
        class="relative flex-shrink inline-block px-3 mt-3 text-left"
        :class="width"
    >
        <select
            v-model="selected"
            :value="value"
            @change="updateValue"
            v-bind="$attrs"
            v-on="$listeners"
            class="block w-full py-2 pr-8 text-left transition duration-150 ease-in-out bg-white border-b-2 outline-none appearance-none sm:text-base sm:leading-5"
            :class="[hasError ? errorClass : activeClass]"
        >
            <option disabled value="0">{{ label }}</option>

            <option
                v-for="(options, index) in option"
                :selected="options.value === value"
                :key="index"
                :value="options.value"
                >{{ options.text }}</option
            >
        </select>
        <div
            class="absolute top-0 right-0 flex items-center px-2 mt-3 text-gray-600 pointer-events-none"
        >
            <svg
                class="w-4 h-4 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
            >
                <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
            </svg>
        </div>
        <p v-if="hasError" class="mt-2 text-sm text-red-600">
            {{ errorMessage }}
        </p>
    </div>
</template>

<script>
// import { formFieldMixin } from "@/mixins/formFieldMixin";

export default {
    // mixins: [formFieldMixin],
    inheritAttrs: false,
    model: {
        prop: "value",
        event: "modified"
    },
    props: {
        option: {
            type: Array,
            required: true
        },
        width: {
            type: String,
            default: "w-full"
        },
        hasError: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String
        },
        label: {
            type: String,
            default: ""
        },
        value: {
            // type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            options: this.option,
            selected: this.value == null ? "0" : this.value,
            errorClass:
                " border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red ",
            activeClass: "border-gray-500 text-gray-600"
        };
    },
    methods: {
        updateValue(event) {
            this.$emit("modified", event.target.value);
        }
    }
};
</script>

<style></style>
